import axios from 'axios'
import Vue from 'vue'
import i18n from '../../../i18n';
import router from '../../../router/index';


const state = {
    token: localStorage.getItem('user-token') || '',
    status: '',
    showErrorMsg: false,
    userRole: localStorage.getItem('user-role'),
    email: localStorage.getItem('email')
}

const getters = {
    isAuthenticated: state => !!state.token,
    authStatus: state => state.status,
    getShowErrorMsg(state){
        return state.showErrorMsg;
    },
    getUserEmail: state => {
        return state.email;
    }
}

const mutations = {
    ['AUTH_REQUEST']: (state) => {
        state.status = 'loading'
    },
    ['AUTH_SUCCESS']: (state, token) => {
        state.status = 'success'
        state.token = token
        //reload the page:
        // document.location.href = "/"
    },
    ['UPDATE_ROLE']: (state, role)  => {
        state.userRole = role
      },
    ['AUTH_ERROR']: (state) => {
        state.status = 'error'
    },
    ['AUTH_LOGOUT']: (state) => {
        state.status = 'logout'
        state.token = null
        localStorage.removeItem('user-token')
    },
    showErrorMsg(state){
        state.showErrorMsg = true
    
    },
    logedUserEmail(state, email){
        state.email = email;
    }
}

const actions = {
    ['AUTH_REQUEST']: ({commit}, data) => {
        return new Promise((resolve) => { 
        commit('AUTH_REQUEST')
        axios.post('user/auth', {
            username: data.username,
            password: data.password,
        }, 
        {}).then(resp => {
            if(!resp.data.error){
                const token = resp.data.data.api_token,
                      accountDto = resp.data.data,
                      accountEmail = resp.data.data.email;
                router.push(`/categories`)

                console.log(accountDto);
                console.log('Token: ', token);
                commit('AUTH_SUCCESS', token)
                localStorage.setItem('user-token', resp.data.data.api_token); 
                localStorage.setItem('account-email', accountEmail);
            } else {
                Vue.toasted.show(resp.message,{
                    theme: 'outline',
                    singleton: true,
                    position:'top-center',
                    action :
                    {
                        text : i18n.tc(`ok`),
                        onClick : (e, toastObject) => {
                            toastObject.goAway(0);
                        }  
                    }
                });
            }
            resolve(resp);
            }).catch(err => {
                if(err.data.data == null){
                    Vue.toasted.show(i18n.tc(`login.no_user_found`),{
                        theme: 'bubble',
                        singleton: true,
                        position:'top-center',
                        action :
                        {
                            text : i18n.tc(`ok`),
                            onClick : (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        }
                    });
                    return false;
                }
            })
        })
    },
    
    ['AUTH_LOGOUT']: ({commit}) => {
        return new Promise((resolve) => {
            commit('AUTH_LOGOUT')
            // remove the axios default header
            delete axios.defaults.headers.common['Authorization']
            resolve()
        })
    }
}


export default {
    state,
    getters,
    mutations,
    actions
}